export default __webpack_public_path__ + "static/media/2_5_1920xSlider5.af41b7af.png";